<template>
  <ForgotPasswordWizard />
</template>

<script setup lang="ts">
import { useAuthLayoutMedia } from '~/composables/useAuthLayoutMedia';
import ForgotPasswordWizard from '~/pages/forgot-password/_components/ForgotPasswordWizard.vue';

definePageMeta({
  layout: 'auth',
});

useAuthLayoutMedia().showAnimation();
</script>
